import cn from 'classnames';

export default function Button({
  children,
  onClick = () => {},
  className,
  ...rest
}) {
  return (
    <button
      className={cn(
        'lds-button-base',
        'lds-dropdown-item',
        'lds-dropdown-item-button',
        className
      )}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}
